import React, {useState} from 'react';
import {EnsureLoggedIn} from "../../admin/EnsureLoggedIn";
import {LauncherLayout} from "../layout/LauncherLayout";
import {Card, Flex, List, Switch, Typography} from "antd";
import axios from "axios";
import {LoadingOverlay} from "../common/loading/component";
import {ReservationDTO} from "../../reservation/types";
import {useQuery} from "react-query";
import {ReservationCard} from "./ReservationCard";
import {useTranslation} from "react-i18next";
import {Label} from "../../commons/translations/Label";
import {useAuthContext} from "../auth/LauncherAuthContext";
import {Heading} from "../../commons/translations/Heading";

const {Title} = Typography;

export const MyReservations = () => {
    const {t} = useTranslation();
    const [showAll, setShowAll] = useState(false);
    const {user} = useAuthContext();

    const {data, isLoading, refetch} = useQuery<ReservationDTO[]>({
        queryKey: ['my-reservations', user?.id, showAll],
        enabled: !!user?.id,
        queryFn: async () => {
            const response = await axios.get(`/api/launcher/my/reservations?all=${showAll}`);
            return response.data;
        }
    });

    return (
        <LauncherLayout>
            <EnsureLoggedIn>
                <Card title={<Title level={2}><Label trl="myReservations.title" /></Title>}>
                    <div style={{marginBottom: '20px'}}>
                        <Flex justify="space-between" align={'center'}>
                            <Heading level={4} trl={"myReservations.filter"} />
                            <Switch
                                checkedChildren={t('myReservations.filter.all')}
                                unCheckedChildren={t('myReservations.filter.active')}
                                checked={showAll}
                                onChange={setShowAll}
                            />
                        </Flex>
                    </div>

                    <LoadingOverlay working={isLoading} />

                    {data && (
                        <List
                            grid={{gutter: 16, xs: 1, sm: 1, md: 2, lg: 3, xl: 3, xxl: 4}}
                            dataSource={data}
                            renderItem={(item) => (
                                <List.Item>
                                    <ReservationCard rsv={item} reload={refetch}/>
                                </List.Item>
                            )}
                        />
                    )}
                </Card>
            </EnsureLoggedIn>
        </LauncherLayout>
    )
}
